<p><strong>Modify Asset Bounding Box</strong></p>

<h3-horizontal-form [labelWidth]="2">
  <h3-horizontal-form-row>
    <span label>Min Coordinate</span>
    <h3-coordinates-control
      [coordinateStore]="assetBoundingBoxStore('min')"
    ></h3-coordinates-control>
  </h3-horizontal-form-row>

  <h3-horizontal-form-row>
    <span label>Max Coordinate</span>
    <h3-coordinates-control
      [coordinateStore]="assetBoundingBoxStore('max')"
    ></h3-coordinates-control>
  </h3-horizontal-form-row>

  <h3-horizontal-form-row>
    <span label>Asset bounding box volume</span>
    <span class="asset-bounding-box">{{
      assetBoundingBoxVolume | number: '1.1-2'
    }}</span>
  </h3-horizontal-form-row>
</h3-horizontal-form>
